import type { CmsFleetCategory } from '@/services/cms-sdk';

type FleetCategoryImageFields = Pick<CmsFleetCategory, 'studioImage' | 'scenicImage'>;

/**
 * Resolves the best image to display for a fleet category, falling back from the
 * studio image to the scenic image. Returns `undefined` when neither is set.
 */
export function getFleetCategoryImage(fleetCategory: FleetCategoryImageFields): string | undefined {
    return fleetCategory.studioImage || fleetCategory.scenicImage;
}

/**
 * True when a fleet category has an image we can render. Catalog vehicles can be
 * missing their scenic image, in which case they should be filtered out of
 * listings rather than rendered with a broken image. See JUCY-1464.
 */
export function hasFleetCategoryImage(fleetCategory: FleetCategoryImageFields): boolean {
    return Boolean(getFleetCategoryImage(fleetCategory));
}
